// extracted by mini-css-extract-plugin
module.exports = {"section":"style_section__1L2KE","edit_section":"style_edit_section__2gAn2"};